import { CloseOutlineIcon } from '@carboncopyco/icons';
import {
  ColorHex,
  TextBase,
  TextButton,
  TooltipBubble,
} from '@carboncopyco/ui';
import { AddRuleButton, RulesManager } from '../RulesManager';

interface AIToolHeaderTitleProps {
  tooltipVisible?: boolean;
  onAddRule?: () => void;
  setTooltipVisible?: (visible: boolean) => void;
}

export const AIToolHeaderTitle = ({
  tooltipVisible,
  setTooltipVisible,
  onAddRule,
}: AIToolHeaderTitleProps) => {
  const closeTooltip = () => {
    setTooltipVisible(false);
  };

  return (
    <RulesManager.Header>
      <TooltipBubble
        absolute={true}
        offset={[0, 35]}
        interactive
        visible={tooltipVisible}
        noArrow
        fixedWidth
        background="primary"
        title={
          <div className="flex flex-col p-3 gap-1 w-[288px]">
            <div className="justify-between w-full flex">
              <TextButton
                label="AI Wizard"
                color="text-ds-accent3-100"
              />

              <div
                className="ml-auto cursor-pointer h-full -mt-0.5"
                onClick={closeTooltip}
              >
                <CloseOutlineIcon
                  color={ColorHex.accent3100}
                  size={16}
                />
              </div>
            </div>

            <TextBase
              label="The AI tool will search for matches on
                  the current page, and all found matches
                will be replaced across the entire demo using the Find & Replace rules."
              color="text-ds-accent3-100"
            />
          </div>
        }
        placement="bottom-end"
      />
      <RulesManager.Header.Title label="AI Wizard" />
      <RulesManager.Header.Action>
        <AddRuleButton onClick={onAddRule} />
      </RulesManager.Header.Action>
    </RulesManager.Header>
  );
};
